export default __webpack_public_path__ + "25feae574f15b8e5fb37d0f7324e7c21.png";